import footerLogo from "../../assets/images/logo-fter.png";
import AppConstants from "../../common/AppConstants";
import CommonMethods from "../../common/CommonMethods";

function Footer() {
  return (
    <>
      <footer>
        <div className="container f-border">
          <div className="row ">
            <div className="col-lg-6 col-sm-12 foot-logo mb-5">
              <div className="first">
                <img src={footerLogo} alt="" />
              </div>
              <div className="two">
                <p>
                  Door No: 11 B&C, <br />
                  SFS Silicon Meadows, Kochi, Kerala-682037
                  <br />
                  India&nbsp;
                  <strong>Phone:</strong> +91-484-4607541 (India)
                  <br />
                  <strong>Email:</strong>{" "}
                  <a href="mailto:support@cloudlas.com">support@cloudlas.com</a>
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-sm-12 foot-link  text-lg-end">
              <span>
                <a
                  href={CommonMethods.getRouteLink(
                    AppConstants.Views.PrivacyPolicy
                  )}
                >
                  Privacy Policy
                </a>
                &nbsp;|&nbsp;
                <a
                  href={CommonMethods.getRouteLink(
                    AppConstants.Views.TermsOfUse
                  )}
                >
                  Terms Of Use
                </a>
              </span>
              <span>
                Copyright &copy; {new Date().getFullYear()} Cloudlas Solutions
                LLP &nbsp;|&nbsp; All rights reserved.
              </span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
export default Footer;
